import React, { useState } from "react";
import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";
import Grid from "@mui/material/Grid";
import DialogContent from "@mui/material/DialogContent";
import Dialog from "@mui/material/Dialog";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import DialogTitle from "@mui/material/DialogTitle";
import NavigateBeforeIcon from "@mui/icons-material/NavigateBefore";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import Close from "@mui/icons-material/Close";
import InnerImageZoom from "react-inner-image-zoom";
import "react-inner-image-zoom/lib/styles.min.css";
import ImageCounter from "../../../components/images/ImageCounter";

import { getImageDegree, rotateImage } from "../../../utils/images";

const styles = {
  dialog: {
    "& .MuiDialog-paper": {
      marginTop: "8px",
      marginBottom: "8px",
      maxHeight: "calc(100vh - 18px)",
    },
  },
  dialogTitle: {
    position: "relative",
    textAlign: "center",
  },
  titleBox: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
  },
  closeButton: {
    position: "absolute",
    right: 8,
    top: 8,
  },
  dialogContent: {
    padding: 0,
  },
  navigationContainer: {
    display: "flex",
  },
  navigationButton: {
    display: "flex",
    flexGrow: 1,
    maxWidth: 40,
    color: "#333",
  },
  imageContainer: {
    position: "relative",
    display: "flex",
    flexGrow: 1,
    justifyContent: "center",
    mr: 0.5,
    borderRadius: 4,
    mb: 3,
    maxHeight: "calc(100vh - 128px)",
    maxWidth: "100%",
    "& .iiz__img": {
      maxHeight: "calc(100vh - 128px)",
      maxWidth: "100%",
      objectFit: "contain",
    },
  },
};

export default function ImageModal({ images, asset, selectedId: defaultId, onClose }) {
  const [selectedId, setSelectedId] = useState(defaultId);

  const currentImage = images.find(image => selectedId === image.id) || images[0];

  const currentImageIndex = images.indexOf(currentImage);
  const InitialRotation = getImageDegree(currentImage?.url);
  const [rotate] = useState(InitialRotation);

  const prevImage = images[currentImageIndex - 1];
  const nextImage = images[currentImageIndex + 1];

  const imgUrl = rotateImage(currentImage?.url, "width", 1024, rotate);

  return (
    <Dialog fullWidth maxWidth="lg" open={true} onClose={onClose} sx={styles.dialog}>
      <DialogTitle sx={styles.dialogTitle}>
        <Box sx={styles.titleBox}>
          {asset.description && (
            <Box>
              <Typography variant="body1" align="center" color="textPrimary">
                {asset.description}
              </Typography>
            </Box>
          )}
          {(asset.barcode || asset.barcodes) && (
            <Box>
              <Typography variant="body1" align="center" color="textSecondary">
                {asset.barcode} {asset.barcodes && asset.barcodes.map(v => v.code).join(" ")}
              </Typography>
            </Box>
          )}
        </Box>
        {onClose && (
          <IconButton sx={styles.closeButton} onClick={onClose}>
            <Close titleAccess="Close" />
          </IconButton>
        )}
      </DialogTitle>
      <DialogContent sx={styles.dialogContent}>
        <Grid container>
          <Grid size={12}>
            <Box sx={styles.navigationContainer}>
              <Button onClick={() => setSelectedId(prevImage?.id)} sx={styles.navigationButton}>
                <NavigateBeforeIcon />
              </Button>
              {currentImage && (
                <Box sx={styles.imageContainer}>
                  <ImageCounter index={currentImageIndex} total={images.length} />
                  <InnerImageZoom src={imgUrl} zoomSrc={imgUrl} zoomScale={2} />
                </Box>
              )}
              <Button onClick={() => setSelectedId(nextImage?.id)} sx={styles.navigationButton}>
                <NavigateNextIcon />
              </Button>
            </Box>
          </Grid>
        </Grid>
      </DialogContent>
    </Dialog>
  );
}
